import { render, staticRenderFns } from "./GroupBankcardBus.vue?vue&type=template&id=3382d1d3"
import script from "./GroupBankcardBus.vue?vue&type=script&lang=js"
export * from "./GroupBankcardBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports